import { isValid } from 'date-fns';

const maxEmailStringLength = 255;
const stringMinLength = 3;
const maxUrlLength = 2000;

export const validateName = (yup, alias, maxLength, isRequired = true) => {
  let result = yup.string().trim();

  if (isRequired) {
    result = result.required("обов'язкове поле");
  }

  return result.max(maxLength, `Будь ласка, введіть ${alias} довжиною до ${maxLength} символів.`);
};

export const validatePhone = (yup, isRequired = true) => {
  let result = yup.string().trim();

  if (isRequired) {
    result = result.required('Обов’язкове поле');
  }

  return result.test('is-valid-phone', 'Вірні формати: +380XXXXXXXXX або 0800XXXXXX', (value) => {
    if (!value?.trim()) return true;

    const shortNumberPattern = /^(?!0800)\d{3,5}$/;
    const hotlinePattern = /^0800\d{6}$/;
    const regularNumberPattern = /^\+380\d{9}$/;

    return shortNumberPattern.test(value) || hotlinePattern.test(value) || regularNumberPattern.test(value);
  });
};

export const validateEmail = (yup, isRequired = true) => {
  let EMAIL_REGX = RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
  let result = yup.string().trim();

  if (isRequired) {
    result = result.required("обов'язкове поле");
  }

  return result
    .matches(EMAIL_REGX, 'Вказана електронна адреса не є вірною')
    .max(maxEmailStringLength, `Будь ласка, введіть електронну адресу довжиною до ${maxEmailStringLength} символів.`);
};

export const validateDateTime = (yup) =>
  yup
    .string()
    .required("обов'язкове поле")
    .test('is-valid-datetime', 'Вказані дата та час не відповідають формату дд.мм.рррр', (value) =>
      isValid(new Date(value))
    );

export const validateUrl = (yup, isRequired = true) => {
  let result = yup.string().trim();

  if (isRequired) {
    result = result.required("обов'язкове поле");
  }

  return result
    .test('is-valid-url', 'Вказане посилання не відповідає формату посилань', isValidUrl)
    .max(maxUrlLength, `Будь ласка, введіть посилання довжиною до ${maxUrlLength} символів.`);
};

export function isValidUrl(url) {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+:]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i'
  );

  return !url?.trim() || pattern.test(url);
}
